import { render, staticRenderFns } from "./AdminPhones.vue?vue&type=template&id=485f181a&scoped=true"
import script from "./AdminPhones.vue?vue&type=script&lang=js"
export * from "./AdminPhones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485f181a",
  null
  
)

export default component.exports